import { FormProvider } from "react-hook-form";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { ICandidateFormProps } from "./Candidate.model";
import { TopicService } from "../../service/Topic/topic.service";
import { FormRow } from "../../components/FormRow";
import { CustomInput } from "../../components/CustomInput";
import { CustomSelect } from "../../components/CustomSelect";
import { CustomMultiSelect } from "../../components/CustomMultiSelect";

const CandidateForm = ({ methods, onSubmit, isEdit }: ICandidateFormProps) => {
  const [allTopics, setAllTopics] = useState<any[]>([]);
  const [skillOptions, setSkillOptions] = useState<{ label: string; value: number }[]>([]);

  const selectedTopics: number[] = (methods.watch("topics") as number[]) || [];

  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Other", value: "other" },
  ];

  // Load all topics once
  useEffect(() => {
    TopicService.getTopics(false).then((res) => {
      setAllTopics(res.data);
    });
  }, []);

  // Rebuild options whenever allTopics or selectedTopics changes
  useEffect(() => {
    const activeOptions = allTopics
      .filter((t) => t.is_active)
      .map((t) => ({ label: t.name, value: t.id }));

    // In edit mode, also include inactive topics that are already selected
    if (isEdit && selectedTopics.length > 0) {
      const inactiveSelected = allTopics
        .filter((t) => !t.is_active && selectedTopics.includes(t.id))
        .map((t) => ({ label: `${t.name} (inactive)`, value: t.id }));
      setSkillOptions([...activeOptions, ...inactiveSelected]);
    } else {
      setSkillOptions(activeOptions);
    }
  }, [allTopics, selectedTopics, isEdit]);

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <FormRow label="Name *" name="name">
          <CustomInput name="name" />
        </FormRow>

        <FormRow label="Email *" name="email">
          <CustomInput name="email" type="email" />
        </FormRow>

        <FormRow label="Gender *" name="gender">
          <CustomSelect
            name="gender"
            options={genderOptions}
            placeholder="Select gender"
          />
        </FormRow>

        <FormRow label="Hobby *" name="hobby">
          <CustomInput name="hobby" />
        </FormRow>

        <FormRow label="Phone *" name="phone">
          <CustomInput name="phone" type="number" />
        </FormRow>

        <FormRow label="Address *" name="address">
          <CustomInput name="address" />
        </FormRow>

        <FormRow label="Skills" name="topics">
          <CustomMultiSelect
            name="topics"
            options={skillOptions}
            placeholder="Select Skills"
          />
        </FormRow>

        <FormRow label="Experience *" name="year_of_experience">
          <CustomInput name="year_of_experience" type="number" />
        </FormRow>

        <div className="text-center mt-4 flex justify-content-start w-full">
          <Button label={isEdit ? "Update" : "Create"} type="submit" />
        </div>
      </form>
    </FormProvider>
  );
};

export default CandidateForm;
